export default "__VITE_ASSET__CTbhB2rX__"